import { render, staticRenderFns } from "./ProjectRegistration.vue?vue&type=template&id=26e85a3e"
import script from "./ProjectRegistration.vue?vue&type=script&lang=js"
export * from "./ProjectRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports